export default () => ({
  user: {},
  token: "",
});
